import { MemberShip } from '@Pages/Detail/props';
import React from 'react';

import s from './style.module.css';

type MemberSwitchProps = {
    memberships: MemberShip[];
    currentMembership: MemberShip;
    isDisplayInitialOffering: boolean;
    onChange: (v: MemberShip) => void;
};

const MemberSwitch = (props: MemberSwitchProps) => {
    const isCurrent = (membership) => {
        return props.currentMembership.id === membership.id;
    };

    const notDuplicationMemberships = (memberships) => {
        const result = [];
        memberships.forEach((membership) => {
            const sameTypeMembership = result.find(
                (v) => v.name === membership.name && v.membershipType === membership.membershipType
            );
            if (!sameTypeMembership) {
                result.push(membership);
            }
        });
        return result;
    };

    const displayMemberships = props.isDisplayInitialOffering
        ? props.memberships
        : notDuplicationMemberships(props.memberships);
    const divisionClass = s[`division${displayMemberships.length}`];

    const hasSomeRegularMembership = props.memberships.filter((v) => v.membershipType === '正会員').length > 1;

    return (
        <div className={s.member_type_switch_box}>
            {displayMemberships.map((v) => (
                <div
                    key={v.id}
                    onClick={() => props.onChange(v)}
                    className={`${s.member_type_switch} ${divisionClass} ${isCurrent(v) ? s.on : s.off}`}
                >
                    {v.name || v.membershipType}
                    {v.isInitialOffering && hasSomeRegularMembership && '（新規募集）'}
                </div>
            ))}
        </div>
    );
};

MemberSwitch.defaultProps = {
    isDisplayInitialOffering: false,
};

export default MemberSwitch;
